export default function EmbedExternalPage({ url }: { url: string }) {
  return <iframe width={"100%"} height={"1000px"} src={url}></iframe>;
}
